<div class="container" *ngIf="isTranslationLoaded">
  <app-leaderboard-header
    (assignmentSelected)="onAssignmentSelected($event)"
    (simulationSelected)="onSimulationSelected($event)"
  >
  </app-leaderboard-header>

  <app-leaderboard-content
    [selectedAssignment]="selectedAssignment"
    [selectedSimulation]="selectedSimulation"
  >
  </app-leaderboard-content>
</div>
